/* eslint-disabled */
import VoucherGroup from "./VoucherGroup";
import EngineMethod from "./EngineMethod";
import Avenant from "./Avenant";
import VoucherExtend from "@/entity/extends/VoucherExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Voucher extends VoucherExtend {

public id!: number;
public label? = '';
public code? = '';
public maxUse!: number;
public voucherGroup!: VoucherGroup;
public branchs: string[] = [];
public insurers: string[] = [];
public packs: string[] = [];
public value!: number;
public type = '';
public isActive!: boolean;
public maxUseByCustomer!: number;
public methodAffect!: EngineMethod;
public startDate?: Date;
public endDate?: Date;
public avenants: Array<Avenant> = [];

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.label= object.label;
       this.code= object.code;
       this.maxUse= object.maxUse;
this.voucherGroup = (object.voucherGroup instanceof VoucherGroup) ? object.voucherGroup : object.voucherGroup ? new VoucherGroup(object.voucherGroup) : object.voucherGroup;
       this.branchs= Array.isArray(object.branchs) ? object.branchs : [];
       this.insurers= Array.isArray(object.insurers) ? object.insurers : [];
       this.packs= Array.isArray(object.packs) ? object.packs : [];
       this.value= object.value;
       this.type= object.type;
       this.isActive= object.isActive;
       this.maxUseByCustomer= object.maxUseByCustomer;
this.methodAffect = (object.methodAffect instanceof EngineMethod) ? object.methodAffect : object.methodAffect ? new EngineMethod(object.methodAffect) : object.methodAffect;
       if(object.startDate){
           this.startDate= new Date(object.startDate);
       }
       if(object.endDate){
           this.endDate= new Date(object.endDate);
       }
            hydrateCollection(object.avenants, Avenant, this.avenants);
      }
      this.postConstruct()
  }

}
